import { computed, Directive, Input, input, signal } from '@angular/core';
import { hlm } from '@spartan-ng/ui-core';
import { cva, type VariantProps } from 'class-variance-authority';

import type { ClassValue } from 'clsx';

export const buttonVariants = cva(
    'tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-opacity-50 disabled:tw-pointer-events-none aria-disabled:tw-opacity-50 aria-disabled:tw-pointer-events-none tw-ring-offset-background',
    {
        variants: {
            variant: {
                default: 'tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/90 hover:tw-no-underline',
                destructive: 'tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/90 hover:tw-no-underline',
                blue: 'tw-bg-blue-500 tw-text-white hover:tw-bg-blue-500/90 focus-visible:tw-ring-blue-500 hover:tw-no-underline',
                outline: 'tw-border tw-border-input hover:tw-bg-accent hover:tw-text-accent-foreground hover:tw-no-underline',
                secondary: 'tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80 hover:tw-no-underline',
                ghost: 'hover:tw-bg-primary/10 hover:tw-text-accent-foreground hover:tw-no-underline',
                link: 'tw-underline-offset-4 hover:tw-underline'
            },
            size: {
                default: 'tw-h-10 tw-py-2 tw-px-4 tw-text-sm',
                xs: 'tw-h-7 tw-px-2 tw-text-sm tw-rounded-sm',
                sm: 'tw-h-9 tw-px-3 tw-text-sm tw-rounded-md',
                lg: 'tw-h-11 tw-px-6 tw-text-base tw-rounded-md',
                icon: 'tw-h-10 tw-w-10 tw-text-sm',
                'icon-sm': 'tw-h-8 tw-w-8 tw-text-sm'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
);
export type ButtonVariants = VariantProps<typeof buttonVariants>;

@Directive({
    selector: '[hlmBtn]',
    standalone: true,
    host: {
        '[class]': '_computedClass()'
    }
})
export class HlmButtonDirective {

    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    public readonly variant = input<ButtonVariants['variant']>('default');
    public readonly size = input<ButtonVariants['size']>('default');

    private readonly _settableClass = signal<ClassValue>('');

    protected _computedClass = computed(() =>
        hlm(buttonVariants({ variant: this.variant(), size: this.size() }), this._settableClass(), this.userClass())
    );

    setClass(value: ClassValue) {
        this._settableClass.set(value);
    }

}
